import { createContext } from 'react';
import { DeliveryFilesProps } from '@/propTypes';

export const deliveriesDefault = { files: [], loading: true };

const DeliveriesContext = createContext<DeliveryFilesProps>(deliveriesDefault);
DeliveriesContext.displayName = 'DeliveryFiles';

export default DeliveriesContext;